import { MapPin, MessageCircle, Navigation, Phone, Star } from "lucide-react";
import { GENERAL_ENQUIRY, LINKS, STORE } from "@/lib/store";

const Row = ({ icon: Icon, label, children }) => (
  <div className="flex gap-4 py-4">
    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#F4EEE2] text-[#8B5A2B]"><Icon className="h-5 w-5" /></span>
    <div><p className="text-xs font-semibold uppercase tracking-wider text-[#5B625D]">{label}</p><div className="mt-1 text-[#1F2421]">{children}</div></div>
  </div>
);

export const VisitUs = () => (
  <section id="visit" className="section-pad scroll-mt-20" data-testid="visit-section">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-12 lg:px-8">
      <div className="md:col-span-5">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8B5A2B]">Visit the shop</p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-bold text-[#1B4332]">Aaiye, milte hain.</h2>
        <div className="mt-6 divide-y divide-[#E5E0D8]">
          <Row icon={MapPin} label="Address"><address className="not-italic" data-testid="store-address">{STORE.address}</address></Row>
          <Row icon={MessageCircle} label="WhatsApp">
            <a href={GENERAL_ENQUIRY} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#1B4332] underline-offset-4 hover:underline" data-testid="contact-whatsapp-link">{STORE.whatsappDisplay}</a>
          </Row>
          <Row icon={Phone} label="Call">
            <a href={LINKS.callPrimary} className="block font-semibold text-[#1B4332] hover:underline" data-testid="contact-call-primary">{STORE.whatsappDisplay}</a>
            <a href={LINKS.call} className="block font-semibold text-[#1B4332] hover:underline" data-testid="contact-call-alt">{STORE.altPhoneDisplay}</a>
          </Row>
        </div>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <a href={LINKS.directions} target="_blank" rel="noopener noreferrer" className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-[#1B4332] px-6 font-semibold text-white transition-colors hover:bg-[#10291F]" data-testid="visit-directions-btn">
            <Navigation className="h-4 w-4" /> Get Directions
          </a>
          <a href={LINKS.reviews} target="_blank" rel="noopener noreferrer" className="inline-flex h-12 items-center justify-center gap-2 rounded-full border-2 border-[#C59B27] px-6 font-semibold text-[#7A5A0B] transition-colors hover:bg-[#FBF1D6]" data-testid="google-reviews-link">
            <Star className="h-4 w-4 fill-[#C59B27] text-[#C59B27]" /> Google Reviews
          </a>
        </div>
      </div>
      <div className="md:col-span-7">
        <div className="h-[320px] overflow-hidden rounded-[1.75rem] border border-[#E5E0D8] shadow-sm sm:h-[440px]">
          <iframe title="Map to RamVilas Kitchen & Hardware Store" src={LINKS.mapEmbed} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-full w-full" data-testid="store-map" />
        </div>
      </div>
    </div>
  </section>
);
